@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  colorpass: $color-primary-green;
  colorfail: $color-primary-red;
  colorincomplete: $color-warning-orange;
}
/* stylelint-enable */

.chartContainerStyle {
  position: 'relative';
  min-height: 8em;
}
